import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Deliverables',
    href: '#deliverables'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Security',
    href: '#security'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="flex justify-between items-center" data-id="element-128">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-129">
            <a href="#" className="group flex items-baseline" data-id="element-130">
              <span className={`font-serif text-2xl font-bold tracking-tight ${isScrolled ? 'text-slate-900' : 'text-slate-900'}`} data-id="element-131">
                Evantiq
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-amber-500 ml-1 group-hover:scale-110 transition-transform" data-id="element-132"></span>
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-133">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-amber-600 ${isScrolled ? 'text-slate-600' : 'text-slate-700'}`} data-id="element-134">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-135">
              Contact Us
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-136">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-md text-slate-700 hover:text-slate-900 focus:outline-none" data-id="element-137">
              {isMobileMenuOpen ? <X size={24} data-id="element-138" /> : <Menu size={24} data-id="element-139" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-slate-100 absolute w-full shadow-lg" data-id="element-140">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-141">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 rounded-md text-base font-medium text-slate-700 hover:text-amber-600 hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-142">
                {link.name}
              </a>)}
            <div className="pt-4 pb-2" data-id="element-143">
              <Button className="w-full" onClick={() => {
            setIsMobileMenuOpen(false);
            document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-144">
                Contact Us
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}